module.exports = __webpack_public_path__ + "static/media/mandibular-instrumental.b6af082c.png";